<template>
    <v-card class="p-4 w-100 mr-4 delegation">
        <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
            <div class="custom-icon-wrapper">
                <v-icon @click="backToDashboardsPage()">custom-icon left-arrow-icon</v-icon>
            </div>
            <v-toolbar-title class="size-16 dark-text p-4 label">{{ $t("res_TabsName_DashboardDepartmentActivity") }}</v-toolbar-title>
        </v-toolbar>
        <hr>
        <div class="container">
            <v-row>
                <v-col cols="4">
                    <v-label class="label_required mb-1">{{ $t("res_Label_SelectStructure") }}<span> *</span></v-label>
                    <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                    :showInternalStructures="true" :showExternalStructures="false"
                    :excludeSelf="true" :isMultiple="false" :addressBook_header="$t('res_Label_SelectUser')"
                    :selectedStructureUser="selectedStructure" @structureUserSelectChanged="structureUserSelectChanged">
                </StructureUserSelector>
                </v-col>
                <v-col cols="4">
                    <v-label class="label_required mb-1 ">{{ $t("res_Label_FromDate") }}<span> *</span></v-label>
                    <v-menu content-class="p-0" v-model="from_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="shrink dtField " :label="$t('res_Label_SelectDate')" :value="utils.dateFormat(fromDate)" readonly solo v-on="on" 
                                append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker :locale="lang" v-model="fromDate" @input="from_date_menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-label class="label_required mb-1">{{ $t("res_Label_ToDate") }}<span> *</span></v-label>
                    <v-menu  content-class="p-0" v-model="to_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field id="date-white-bg" class="shrink dtField " :label="$t('res_Label_SelectDate')" :value="utils.dateFormat(toDate)" readonly solo v-on="on" 
                                append-icon="mdi-calendar" :tabindex="-1" v-bind="attrs">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker :locale="lang" v-model="toDate" @input="to_date_menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
             <v-row>
                <div class="d-flex justify-space-between align-items-center">
                    <div class="d-flex gap-2 mt-0">
                        <v-btn @click="clearFilter()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn dense class="primary" @click="updateFilter()">
                            {{ $t("res_ButtonText_Search") }}
                        </v-btn>
                    </div>
                </div>
            </v-row>
        </div>
        <hr>
        <v-row>
            <v-col cols="4">
                <v-data-table :headers="structureHeaders" :items="structures" :items-per-page="10" item-key="name"
                    @click:row="handleRowClick" :footer-props="{itemsPerPageText: $t('res_Msgs_RowsPerPage'), itemsPerPageAllText: $t('res_CardHeaders_All')}">
                    <template v-slot:no-data>
                        <div class="flex-1">
                            <p class="m-0">{{ $t("res_Label_NoData") }}</p>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="8">
                <div v-if="chartflag">
                    <canvas id="myBarChart"></canvas>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <div v-if="listCorrespondences.length" class="d-flex justify-end align-right">
                <v-btn class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')">
                    <v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon>
                </v-btn>
                <v-btn class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')">
                    <v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon>
                </v-btn>
            </div>
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-data-table :headers="correspondenceHeaders" :items="listCorrespondences" :items-per-page="10" :footer-props="{itemsPerPageText: $t('res_Msgs_RowsPerPage'), itemsPerPageAllText: $t('res_CardHeaders_All')}">
                        <template v-slot:no-data>
                            <div class="flex-1">
                                <p class="m-0">{{ $t("res_Label_NoData") }}</p>
                            </div>
                        </template>
                        <template v-slot:[`item.dueIn`]="{ item }">
                            <span :style="{ color: calculateDueIn(item.dueDate) > 0 ? '#15d649' : '#fa0707' }">
                                {{ calculateDueIn(item.dueDate) }}
                            </span>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex gap-2 justify-content-end"  style="cursor:pointer !important">
                                <div  class="custom-icon-wrapper" v-tooltip="$t('res_ButtonText_VisualTracking')">
                                    <div @click="openVisualTrackingFromInbox(item.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24">
                                            <path fill="#667593" d="M19 20.5q-.898 0-1.586-.562t-.855-1.438H11q-1.458 0-2.479-1.021T7.5 15t1.021-2.479T11 11.5h2q1.031 0 1.766-.735q.734-.736.734-1.769t-.734-1.764T13 6.5H7.44q-.17.875-.856 1.438T5 8.5q-1.042 0-1.77-.728q-.73-.729-.73-1.77t.73-1.771T5 3.5q.898 0 1.584.563q.685.562.857 1.437H13q1.458 0 2.479 1.021T16.5 9t-1.021 2.479T13 12.5h-2q-1.031 0-1.766.736q-.734.735-.734 1.768t.735 1.764q.734.732 1.765.732h5.56q.17-.875.856-1.437T19 15.5q1.042 0 1.77.729q.73.728.73 1.769t-.73 1.771T19 20.5M5 7.5q.617 0 1.059-.441Q6.5 6.617 6.5 6t-.441-1.059Q5.617 4.5 5 4.5t-1.059.441Q3.5 5.383 3.5 6t.441 1.059Q4.383 7.5 5 7.5"/>
                                        </svg>

                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </v-row>
        <v-dialog v-model="visualTrackingDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
            width="100%" fullscreen>
            <div class="dialog-header">
                <!-- <v-icon class="back-btn">mdi-chevron-left</v-icon> -->
                <v-btn class="close-btn light-btn tracker-close" icon dark @click="visualTrackingDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-body h-100">
                <iframe id="trackingFrame" :src="trackingFrameSrc"
                    style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
            </div>
        </v-dialog>
    </v-card>
</template>
<style scoped></style>
<script>
import constants from "@/assets/js/constants.js";
import axios from "axios";
import MultiSelect from 'vue-multiselect';
import * as utils from '@/assets/js/common.js';
import router from '../../router/index.js';
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import { Chart, CategoryScale, LinearScale, LineController,BarController, LineElement,BarElement,PointElement, Title, Tooltip, Legend  } from 'chart.js';
export default {
    components: { MultiSelect,StructureUserSelector },
    data() {
        const isArabic = localStorage.getItem('lang') == 'ar';
        return {
            structureHeaders: localStorage.getItem('lang') == 'en' ? [
                { text: 'Status', value: 'name', 'sortable': false },
                { text: 'Incoming', value: 'incoming', 'sortable': false },
                { text: 'Outgoing', value: 'outgoing', 'sortable': false },
                { text: 'Internal', value: 'internal', 'sortable': false },
                { text: 'Decree', value: 'decree', 'sortable': false },
                { text: 'Circular', value: 'circular', 'sortable': false },
                { text: 'Total', value: 'total', 'sortable': false },
            ] : [
                { text: 'الحالة', value: 'name', 'sortable': false },
                { text: 'الوارد', value: 'incoming', 'sortable': false },
                { text: 'الصادر', value: 'outgoing', 'sortable': false },
                { text: 'الداخلي', value: 'internal', 'sortable': false },
                { text: 'قرارات', value: 'decree', 'sortable': false },
                { text: 'تعاميم', value: 'circular', 'sortable': false },
                { text: 'المجموع', value: 'total', 'sortable': false },
            ],
            correspondenceHeaders: localStorage.getItem('lang') == 'en' ? [
                { text: 'Reference No.', value: 'reference', 'sortable': false },
                { text: 'Privacy', value: 'privacy', 'sortable': false },
                { text: 'Due In', value: 'dueIn', 'sortable': false },
                { text: 'Subject', value: 'subject', 'sortable': false },
                { text: 'Category', value: 'category', 'sortable': false },
                { text: '', value: 'actions', 'sortable': false },
            ] : [
                { text: 'الرقم المرجعي', value: 'reference', 'sortable': false },
                { text: 'الخصوصية', value: 'privacy', 'sortable': false },
                { text: 'تستحق بغضون', value: 'dueIn', 'sortable': false },
                { text: 'الموضوع', value: 'subject', 'sortable': false },
                { text: 'النوع', value: 'category', 'sortable': false },
                { text: '', value: 'actions', 'sortable': false },
            ],
            dataIndexToFlag: {
                0: 'Draft',
                1: 'InProgress',
                2: 'Completed',
                3: 'Canceled',
                4: 'Signed'
            },
            dataIndexToCategoryFlag: {
                0: 'Incoming',
                1: 'Outgoing',
                2: 'Internal',
                3: 'Decree',
                4: 'Circular'
            },
            listCorrespondences: [],
            utils: utils,
            selectedStructure: null,
            fromDate: "",
            toDate: "",
            from_date_menu: false,
            to_date_menu: false,
            structures: [],
            series: [{
                data: [],
                headerLabel: ''
            }],
            chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                title: {
                    display: true,
                    text: localStorage.getItem('lang') == 'en' ? 'Correspondence Status' : 'حالة المراسلات',
                    font: {
                        size: 22,
                        family: 'Helvetica, sans-serif',
                        weight: 'bold',
                    },
                    padding: {
                        top: 15,
                        bottom: 20,
                    },
                    color: '#212529',
                },
                tooltip: {
                    enabled: true,
                    mode: 'index',
                    intersect: false,
                    backgroundColor: 'rgba(34, 34, 34, 0.9)',
                    titleFont: {
                        size: 16,
                        weight: 'bold',
                        family: 'Arial',
                    },
                    bodyFont: {
                        size: 13,
                        family: 'Arial',
                    },
                    padding: 12,
                    cornerRadius: 8,
                    displayColors: true,
                },
            },
            scales: {
                x: {
                    ticks: {
                        font: {
                            size: 15,
                            family: 'Arial',
                        },
                        color: '#495057',
                    },
                    grid: {
                        display: false,
                    },
                },
                y: {
                    beginAtZero: true,
                    grid: {
                        color: 'rgba(150, 150, 150, 0.3)',
                        borderDash: [4, 4],
                    },
                    ticks: {
                        font: {
                            size: 13,
                            family: 'Arial',
                        },
                        color: '#495057',
                    },
                },
            },
            onClick: (event, elements) => {
                if (elements.length > 0) {
                    const datasetIndex = elements[0].datasetIndex;
                    const index = elements[0].index;
                    this.handleBarClick(event, datasetIndex, index);
                }
            }
        },

        charts:null,
        chartflag: false,
        tableCategory: '',
        isExport: false,
        exportType: '',
        visualTrackingDialog: false,
        trackingFrameSrc: '',
        lang: localStorage.getItem('lang'),
        mappedCategoryFlag: ''
        }
    },
    watch: {
    },
    methods: {
        openVisualTrackingFromInbox(documentId = 0)
        {
                this.signingHistoryDialog = false
                var lang = localStorage.getItem('lang')
                lang = ((lang == null || lang == undefined) ? 'en' : lang);
                window.setVisualTrackingData(documentId);
                this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                this.visualTrackingDialog = true
                //window.open(this.trackingFrameSrc, "_blank");
        },
        buildCharts() {
                const ctx = document.getElementById('myBarChart');
                if (this.charts) {
                    this.charts.destroy(); 
                } 
                const categories = localStorage.getItem('lang') == 'en' ? 
                    ['Incoming', 'Outgoing', 'Internal', 'Decree', 'Circular'] : 
                    ['وارد', 'صادر', 'داخلي', 'قرارات', 'تعاميم'];

                this.charts = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: categories,  
                        datasets: [
                            {
                                label: localStorage.getItem('lang') == 'en' ? 'Count' : 'العدد',
                                backgroundColor: [
                                    'rgba(75, 192, 192, 0.7)',
                                    'rgba(255, 159, 64, 0.7)',
                                    'rgba(255, 205, 86, 0.7)',
                                    'rgba(54, 162, 235, 0.7)',
                                    'rgba(153, 102, 255, 0.7)'
                                ],
                                borderColor: [
                                    'rgba(75, 192, 192, 1)',
                                    'rgba(255, 159, 64, 1)',
                                    'rgba(255, 205, 86, 1)',
                                    'rgba(54, 162, 235, 1)',
                                    'rgba(153, 102, 255, 1)'
                                ],
                                borderWidth: 2,  
                                data: this.series[0].data,  
                                fill: true,
                                borderRadius: 12,  
                                barPercentage: 0.8,  
                                hoverBackgroundColor: 'rgba(0, 0, 0, 0.2)',  
                                hoverBorderWidth: 3,
                                        },
                                    ],
                        },
                         options: this.chartOptions
                });
            },
            getListCorrespondences(flagStatus,flagCategory) {
            window.showLoading();
            const structureId = this.selectedStructure?.id ?? ''
            if(this.isExport) {
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios({
                    url: constants.baseApiUrl + `Dashboard/CategoryCorrespondences?structureId=${structureId}&fromDate=${this.fromDate}&toDate=${this.toDate}&flagStatus=${flagStatus}&flagCategory=${flagCategory}&isExport=${this.isExport}&exportType=${this.exportType}`,
                    method: 'POST',
                    responseType: 'blob',
                })
                .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch((err) => window.hideLoading())
                    .finally(() => window.hideLoading())
                    this.isExport = false;
                    this.exportType = '';
            } else {
                axios.post(constants.baseApiUrl + `Dashboard/CategoryCorrespondences?structureId=${structureId}&fromDate=${this.fromDate}&toDate=${this.toDate}&flagStatus=${flagStatus}&flagCategory=${flagCategory}&isExport=${this.isExport}&exportType=${this.exportType}`, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            this.listCorrespondences = res.data;
                        }
                    })
                    .catch(error => window.hideLoading())
                    .finally(() => window.hideLoading())
            }
        },
        calculateDueIn(dueDate) {
            if (dueDate !== null){
            const today = new Date();
            const dueDateTime = new Date(dueDate);
            const timeDifference = dueDateTime - today;
            const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

            return `${daysDifference} days`;
            }
            return;
        },
        structureUserSelectChanged(userSelected){
				this.selectedStructure = userSelected
        },
        exportToExcelOrPdf(exportType) {
            this.isExport = true;
            this.exportType = exportType;
            this.getListCorrespondences(this.tableCategory,this.mappedCategoryFlag);
        },
        handleBarClick(event, chartContext, config) {
            const dataIndex = config;
            const mappedFlag = this.chartOptions.plugins.title.text;
            this.mappedCategoryFlag = this.dataIndexToCategoryFlag[dataIndex];
            this.tableCategory = mappedFlag;
            this.getListCorrespondences(mappedFlag,this.mappedCategoryFlag);
        },
        async getUserCorrespondenceStatus() {
            this.structures = [];
            const  structureId = this.selectedStructure?.id ?? ''
            window.showLoading();
            try {
                const res= await axios.post(constants.baseApiUrl + `Dashboard/UserCorrespondenceStatus?structureId=${structureId}&fromDate=${this.fromDate}&toDate=${this.toDate}`);
                if (res.data !== null) {
                    res.data.map(async (element) => {
                        try {
                            this.structures.push({
                                id: element.id,
                                name: element.name,
                                incoming: element.correspondenceCounts.Incoming,
                                outgoing: element.correspondenceCounts.Outgoing,
                                internal: element.correspondenceCounts.Internal,
                                decree: element.correspondenceCounts.Decree,
                                circular: element.correspondenceCounts.Circular,
                                total: (element.correspondenceCounts.Incoming + element.correspondenceCounts.Outgoing + element.correspondenceCounts.Internal + element.correspondenceCounts.Decree + element.correspondenceCounts.Circular),
                            });
                        } catch (error) {
                            console.error(`Error fetching counts for structure ${element.id}:`, error);
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching structures:', error);
            } finally {
                window.hideLoading();
            }
        },
        handleRowClick(item) {
            this.series[0].data = [];
            this.listCorrespondences = [];
            window.showLoading();
            try {
                this.chartOptions.plugins.title.text = item.name;
                 this.chartflag = true
            } catch (error) {
                console.log(error);
            } finally {
                setTimeout(() => {
                    this.series[0].data.splice(0, 5, item.incoming, item.outgoing, item.internal, item.decree, item.circular);
                    window.hideLoading();
                    this.buildCharts(item)
                }, 500);
            }
        },
        updateFilter() {
            if(!this.validateDate()){
                    return;
                }
            if(this.selectedStructure == null || this.selectedStructure == undefined){
                 window.showAlert("res_Msgs_please_Select_Users", "warning");
                 return;
                }

            this.getUserCorrespondenceStatus()   
        },
        validateDate()
        {
            var now = new Date().toISOString().slice(0, 10);
                
                if(this.fromDate && this.toDate){
                    if(this.fromDate > this.toDate){
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        return false;
                    }
                    return true;
                }else {
                    window.showAlert("res_Msgs_EnterDates", "warning");
                    return false;
                }

        },
        clearFilter() {
            this.fromDate = ''
            this.toDate = ''
            this.selectedStructure = null;
        },
        backToDashboardsPage() {
            router.push({ name: 'dashboards' })
        },
    },
    async mounted() {
        Chart.register(CategoryScale, LinearScale, LineController, BarController,LineElement,BarElement, PointElement, Title, Tooltip, Legend );
    }
};
</script>
<style scoped>
.label {
    font-weight: 500;
    font-size: 12px;
}
</style>